export const closureSteps = [
  "Pre-Closure Checks",
  "Study Locking Checks",
  "Post Study Closure Checks",
  "Confirmation of Study Closure",
];

export const closureChecksList = [
  {
    desc: "Lorem ipsum is placeholder text commonly used in the graphic",
    checks: [
      {
        label:
          "Check if all visits and mandatory forms for all included participants are completed",
        key: "participant_visit_completion",
        errorMessage:
          "Some participants have incomplete visits or mandatory forms. Please ensure all required data is submitted.",
      },
      {
        label: "Check if all queries are resolved",
        key: "queries_resolved",
        errorMessage:
          "There are unresolved queries that require attention. Please review and resolve them before proceeding.",
      },
      {
        label: "Check if all forms are locked and signed-off",
        key: "forms_signed_off",
        errorMessage:
          "Not all forms have been locked and signed off. Please verify and complete the necessary approvals.",
      },
    ],
  },
  {
    desc: "Lorem ipsum is placeholder text commonly used in the graphic",
    checks: [
      {
        label: "All forms are to be locked",
        key: "forms_locked",
        errorMessage:
          "Some forms remain unlocked. Please review and lock them.",
      },
      {
        label: "Disable survey links and mobile API calls for data updates",
        key: "survey_links_disabled",
        errorMessage:
          "Survey links and API calls for data updates are still active. Please disable them to proceed.",
      },
      {
        label: "Disable user accounts apart from Study Manager & Data Manager",
        key: "user_accounts_disabled",
        errorMessage:
          "User accounts other than Study Manager and Data Manager are still active. Please disable unauthorized access.",
      },
    ],
  },
  {
    desc: "Lorem ipsum is placeholder text commonly used in the graphic",
    checks: [
      {
        label: "Export data and provide a download link",
        key: "export_data",
        errorMessage:
          "Data export was not completed successfully. Please retry the export process.",
      },
      // {
      //   label: "Initiate a DB backup process and create a backed-up file",
      //   key: "db_backup",
      //   errorMessage:
      //     "Database backup was not created successfully. Please initiate the backup process again.",
      // },
      // {
      //   label: "Generate study closure report",
      //   key: "study_closure_report",
      //   errorMessage:
      //     "The study closure report could not be generated. Please check the system logs and retry.",
      // },
    ],
  },
];

export const waitFn = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
};
